import axios, { AxiosResponse } from 'axios';
import { ProcurementItemDto } from '../../models/procurement/documentType.model';

const prefix: string = 'Procurement/';

export const getProcurementExport = (languageCode: string): Promise<AxiosResponse<ProcurementItemDto[]>> => {
    return axios.get<ProcurementItemDto[]>(`${prefix}GetProcurementExport/${languageCode}`);
};
